"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(str) {
    str = str.replace(/[^0-9]/g, '');
    let tmp = '';
    if (str.length < 4) {
        return str;
    }
    else if (str.length < 7) {
        tmp += str.substring(0, 3);
        tmp += '-';
        tmp += str.substring(3);
        return tmp;
    }
    else if (str.length < 11) {
        tmp += str.substring(0, 3);
        tmp += '-';
        tmp += str.substring(3, 6);
        tmp += '-';
        tmp += str.substring(6);
        return tmp;
    }
    else {
        tmp += str.substring(0, 3);
        tmp += '-';
        tmp += str.substring(3, 7);
        tmp += '-';
        tmp += str.substring(7);
        return tmp;
    }
}
exports.default = default_1;
